export enum DocumentCategoryEnum {
  Document = 1,
  Project = 2,
  Layer = 3,
  Vectorization = 4,
  Overlay = 5,
  Heatmap = 6,
  IFrame = 7,
  Integration = 8,
  Connection = 9,
  Folder = 136,
  TileService = 11,
  Extrusion = 12,
  Group = 13,
  DataView = 14,
  Share = 15,
  Nomenclature = 16,
  VectorTiles = 17,
  Form = 18,
  Ticket = 19,
  Registry = 20,
  Flow = 21,
  Task = 48,
  Georeference = 59,
  DocumentsCollection = 106,
  OrganizationCollection =194,
  MBTileCollection = 107,
  Trigger = 200,
  SQLScript = 248,
  Analytics = 258,
  Process = 285,
  DataSourceCollection = 296,
  Chat = 344
}

